import React from 'react';
import { useIdleLogoutContext } from '@context/IdleLogoutContext';

const IdleLogout = () => {
  const { showWarning, remaining, stayLoggedIn, isAuthenticated } = useIdleLogoutContext();

  if (!isAuthenticated) return null;

  return (
    showWarning && (
      <div className="idle-warning-modal">
        <div className="modal-content">
          <h4>You've been inactive</h4>
          <p>You will be logged out in {remaining} seconds due to inactivity.</p>
          <button type='button' onClick={stayLoggedIn}>Stay Logged In</button>
        </div>
      </div>
    )
  );
};

export default IdleLogout;